const binding = { modules: {}, dataActions: {} };

    (binding.modules['hobart'] = {
        c: () => require('partner/themes/hobart/hobart.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['cart-icon','container-with-header','content-block','header','image-list','order-details','tile-list-item','tile-list'],
        iNM: false,
        ns: '__local__',
        n: 'hobart',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'hobart.theme.settings.json',
        md: 'src/themes/hobart'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };